import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

import { PAGE_SIZE } from './QuestionList.constants';

export const getQaQuestionTags = () =>
  httpClient.get(apis.GET_QA_QUESTION_TAGS, null, { ignore: true });

const amendPayloadPageSize = (payload) => ({
  ...payload,
  pageSize: PAGE_SIZE,
});

const amendPayloadQaQuestionList = ({ qType, courseTagId, bookTagId, pageNo }) =>
  amendPayloadPageSize({
    qType: qType ? qType : 'latest',
    courseTagId: courseTagId ? courseTagId : 0,
    bookTagId: bookTagId ? bookTagId : 0,
    pageNo,
  });

export const getPublicQaQuestionList = (payload) => {
  return httpClient.get(apis.getPublicQaQuestionList(amendPayloadQaQuestionList(payload)), null, {
    ignore: true,
  });
};

export const getQaQuestionList = (payload) => {
  return httpClient.get(apis.getQaQuestionList(amendPayloadQaQuestionList(payload)), null, {
    ignore: true,
  });
};

export const getQaSearchList = (payload) =>
  httpClient.post(apis.GET_QA_SEARCH_LIST, amendPayloadPageSize(payload));
